import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav className="container pt-3" style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>
      <Link
        to="/"
        style={{
          color: "#999",
          fontWeight: 500,
          textDecoration: "none",
        }}
      >
        Homepage
      </Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        return (
          <React.Fragment key={name}>
            <FaChevronRight
              style={{ margin: "0 8px", fontSize: "12px", color: "#999" }}
            />
            {isLast ? (
              <span
                style={{
                  color: "#1e2a78",
                  fontWeight: 700,
                  textTransform: "capitalize",
                }}
              >
                {decodeURIComponent(name.replace(/-/g, " "))}
              </span>
            ) : (
              <Link
                to={routeTo}
                style={{
                  color: "#999",
                  fontWeight: 500,
                  textDecoration: "none",
                  textTransform: "capitalize",
                }}
              >
                {decodeURIComponent(name.replace(/-/g, " "))}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
